import Esigner from './Esigner';

export default class FirmanteContratoIngresoTardio extends Esigner {
    constructor(
        public email: string,
        public firstName: string,
        public lastName: string,
        public phoneNumber: string,
        public cedula: string,
        public nacionalidad: string,
        public direccionCompleta: string,
        public provincia: string,
        public numeroSolicitud: number,
        public saldoCCILetras: string,
        public saldoCCI: number,
        public fechaNacimiento: string,
        public telefonoResidencial: string,
        public userIdentityEncrypt: string,
        public tokenUser: string
    ) {
        super(email, firstName, lastName, phoneNumber, cedula);
    }
}